import { render } from "./BotaoPainelOrcamento.vue?vue&type=template&id=6a226021"
import script from "./BotaoPainelOrcamento.vue?vue&type=script&lang=js"
export * from "./BotaoPainelOrcamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__